(function ($) {
    $.fn.extend({
        leanModal: function (options) {
            var self = this;

            var defaults = {
                top: 100,
                overlay: 0.5,
                closeButton: null,
                focusElement: null,
                clickCallback: null, // New callback option
                closeCallback: null
            };
            var overlay = $("<div id='lean_overlay'></div>");
            if ($("body").find('#lean_overlay').length == 0) {
                $("body").append(overlay);
            }
            options = $.extend(defaults, options);

            self.close_modal = function (modal_id) {
                console.log(modal_id);
                $("#lean_overlay").fadeOut(200);
                $(modal_id).css({ "display": "none" });
                $('.mm-page').css({ 'position': 'relative' });
            }

            self.modal_id = '';

            return this.each(function () {
                var o = options;

                $(this).click(function (e) {

                    $('.mm-page').css({ 'position': 'unset' }); 

                    var modal_id = $(this).attr("href");
                    self.modal_id = modal_id;
                    console.log(self.modal_id, 'modal_id');

                    $("#lean_overlay, .close-form").click(function () {
                        self.close_modal(modal_id)

                        // Call the click callback function if provided
                        if (typeof o.closeCallback === 'function') {
                            o.closeCallback.call(this);
                        }
                    });

                    $(o.closeButton).click(function () {
                        self.close_modal(modal_id)
                    });

                    if (o.focusElement) {
                        $(o.focusElement).focus();
                    }

                    var modal_height = $(modal_id).outerHeight();
                    var modal_width = $(modal_id).outerWidth();
                    $("#lean_overlay").css({ "display": "block", opacity: 0 });
                    $("#lean_overlay").fadeTo(200, o.overlay);

                    $(modal_id).css({
                        "display": "block",
                        "position": "absolute",
                        "opacity": 0, "z-index": 11000,
                        "left": 50 + "%", "margin-left": -(modal_width / 2) + "px",
                        "top": o.top + "px"
                    });

                    $(modal_id).fadeTo(200, 1);
                    scrollToTop();

                    // Call the click callback function if provided
                    if (typeof o.clickCallback === 'function') {
                        o.clickCallback.call(this);
                    }

                    e.preventDefault();
                })
            });

            function scrollToTop() {
                $('html, body').animate({ scrollTop: 0 }, 600);
            }
        }
    })
})(jQuery);